import { useCallback } from 'react'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'

import { RadixDialog } from '@jotta/ui/RadixDialog'
import { RadixModal } from '@jotta/ui/RadixModal'

export function UserAlreadyInvitedDialog({
  user,
  onClose,
}: {
  user: string | null
  onClose: () => void
}) {
  const onOpenChange = useCallback(
    (open: boolean) => {
      if (!open) {
        onClose()
      }
    },
    [onClose],
  )

  return (
    <RadixModal open={Boolean(user)} onClose={onOpenChange}>
      <RadixDialog
        buttons={[{ action: 'close', label: t`Ok`, type: 'outline' }]}
        onClose={onOpenChange}
      >
        <p>
          <Trans>
            <strong>{user}</strong> is already a member of this folder!
          </Trans>
        </p>
      </RadixDialog>
    </RadixModal>
  )
}
